import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IExamCreate, IExamPool } from '@tsin-core/models/exam.model';
import {
  IExaminer,
  IExaminerDelete,
  IExaminersReq,
  IExaminerUpdate,
  ISendAvailabilityEmailInput,
  IUpdateAvailabilityInput,
} from '@tsin-core/models/examiner.model';
// import {
//   IExaminersReq,
//   ISendAvailabilityEmailInput,
//   IUpdateAvailabilityInput,
// } from '@tsin-core/states/examiner/examiner.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const EXAMINER_URL = `${environment.apiUrl}/examiner`;
const WWU_URL = `${environment.wwuBaseUrl}/user`;

@Injectable({
  providedIn: 'root',
})
export class ExaminerService {
  http: HttpClient = inject(HttpClient);

  createExaminer(examiner: Omit<IExamCreate, 'id'>): Observable<IExaminer> {
    return this.http.post<IExaminer>(EXAMINER_URL, examiner);
  }

  updateExaminer(examiner: Omit<IExaminerUpdate, 'id'>): Observable<IExaminer> {
    return this.http.put<IExaminer>(EXAMINER_URL, examiner);
  }

  getExaminers(payload: IExaminersReq): Observable<IExaminer[]> {
    return this.http.get<IExaminer[]>(WWU_URL, { params: { role: payload.type, department: 'Exam' } });
    // return this.http.get<IModerator[]>(`${MODERATOR_URL}?department=PRO&role=proModerator`);
  }

  getExaminersAvailability(examId: string): Observable<IExaminer[]> {
    return this.http.get<IExaminer[]>(`${EXAMINER_URL}/exam/${examId}`);
  }

  deleteExaminer(id: string): Observable<IExaminerDelete> {
    return this.http.delete<IExaminerDelete>(`${EXAMINER_URL}/single/${id}`);
  }

  getAssignedExaminers(examId: string): Observable<IExaminer[]> {
    return this.http.get<IExaminer[]>(`${EXAMINER_URL}/exam/${examId}`);
  }

  sendAvailEmail(input: ISendAvailabilityEmailInput) {
    return this.http.post(EXAMINER_URL + '/send-availability-email', input, {
      responseType: 'text',
    });
  }

  updateAvail(input: IUpdateAvailabilityInput) {
    return this.http.patch(EXAMINER_URL + '/update-availability', input);
  }

  updateExaminerStatus(input: { examinerId: string, status: string }) {
    return this.http.patch(EXAMINER_URL + '/update-status', input);
  }

  createExamPool(examPool: IExamPool): Observable<any> {
    return this.http.post<any>(`${EXAMINER_URL}/create-examiner-pool`, examPool);
  }

  sigInOutExaminer(payload: any): Observable<any> {
    return this.http.post<IExaminer>(`${EXAMINER_URL}/signin`, payload);
  }

  sigInOutExaminerHistory(payload: any): Observable<any> {
    return this.http.get<IExaminer>(`${EXAMINER_URL}/signin`, { params: payload });
  }

  getExaminerByUserId(userId: string): Observable<IExaminer[]> {
    return this.http.get<IExaminer[]>(`${EXAMINER_URL}/user/${userId}`);
  }

}
